import { LightningElement, api, wire } from "lwc";
import { assignedSlotNames, assignedElements } from "common/slot";
import { attrToBool } from "common/helpers";
import { ResizeObserverAdapter } from "common/resizeObserverAdapter";
import { BREAKPOINT_WIDTHS } from "common/mediaQueryAdapter";
import { LabelsAdapter } from "common/labelsAdapter";

var data$9 = {
  showUnits: "%{count} Einheiten anzeigen",
  hideUnits: "%{count} Einheiten ausblenden",
};
data$9.showUnits;
data$9.hideUnits;

var data$8 = {
  showUnits: "Show %{count} Units",
  hideUnits: "Hide %{count} Units",
};
data$8.showUnits;
data$8.hideUnits;

var data$7 = {
  showUnits: "Mostrar %{count} unidades",
  hideUnits: "Ocultar %{count} unidades",
};
data$7.showUnits;
data$7.hideUnits;

var data$6 = {
  showUnits: "Mostrar %{count} unidades",
  hideUnits: "Ocultar %{count} unidades",
};
data$6.showUnits;
data$6.hideUnits;

var data$5 = {
  showUnits: "Afficher %{count} unités",
  hideUnits: "Masquer %{count} unités",
};
data$5.showUnits;
data$5.hideUnits;

var data$4 = {
  showUnits: "Mostra %{count} unità",
  hideUnits: "Nascondi %{count} unità",
};
data$4.showUnits;
data$4.hideUnits;

var data$3 = {
  showUnits: "%{count} 単元を表示",
  hideUnits: "%{count} 単元を非表示",
};
data$3.showUnits;
data$3.hideUnits;

var data$2 = {
  showUnits: "유닛 %{count}개 표시",
  hideUnits: "유닛 %{count}개 숨기기",
};
data$2.showUnits;
data$2.hideUnits;

var data$1 = {
  showUnits: "Mostrar %{count} unidades",
  hideUnits: "Ocultar %{count} unidades",
};
data$1.showUnits;
data$1.hideUnits;

var data = {
  showUnits: "显示 %{count} 个单元",
  hideUnits: "隐藏 %{count} 个单元",
};
data.showUnits;
data.hideUnits;

var locales = /*#__PURE__*/ Object.freeze({
  __proto__: null,
  de: data$9,
  en: data$8,
  es: data$7,
  esMX: data$6,
  fr: data$5,
  it: data$4,
  ja: data$3,
  ko: data$2,
  ptBR: data$1,
  zhCN: data,
});

class contentBrick extends LightningElement {
  @api summary = null;
  @api titleMode = "anchor";
  _expanded = false;
  childCount = 0;
  isNarrow = false;
  @wire(LabelsAdapter, {
    locales,
    options: "$labelOptions",
  })
  labels = null;
  slots = [];
  get labelOptions() {
    return {
      showUnits: {
        count: this.childCount,
      },
      hideUnits: {
        count: this.childCount,
      },
    };
  }
  get toggleLabel() {
    return this.expanded ? this.labels.hideUnits : this.labels.showUnits;
  }
  get config() {
    return {
      titleMode: this.titleMode,
      variant: "brick-tile",
    };
  }
  get borderTopStyles() {
    return `border-top-color: ${this.summary.color};`;
  }
  onNavigate() {
    this.dispatchEvent(
      new CustomEvent("navigate", {
        detail: this.summary,
      })
    );
  }
  handleClick() {
    this.template
      .querySelector(".content__list")
      .classList.add("expand__animation");
    this.dispatchEvent(new CustomEvent("expand"));
    this._expanded = !this._expanded;
  }
  get computedMarginTop() {
    const contentList = this.template.querySelector(".content__list");
    if (contentList?.scrollHeight) {
      if (this.isNarrow) {
        return this.expanded ? 0 : -contentList.scrollHeight - 50;
      } else {
        return this.expanded ? 0 : -contentList.scrollHeight - 25;
      }
    }
    return 0;
  }
  get computedStyle() {
    return `margin-top: ${this.computedMarginTop}px;`;
  }
  @api get expanded() {
    return this._expanded;
  }
  set expanded(value) {
    this._expanded = attrToBool(value);
  }
  @api ariaHidden = this.expanded ? "false" : "true";
  @api tabIndex = this.expanded ? 0 : -1;
  get showButton() {
    return this.slots.includes("child-item");
  }
  handleSlotChange() {
    this.slots = assignedSlotNames(this.template);
    const childSlot = this.template.querySelector('slot[name="child-item"]');
    this.childCount = assignedElements(childSlot).length;
  }
  get iconSymbol() {
    return this.expanded ? "chevronup" : "chevrondown";
  }
  @wire(ResizeObserverAdapter, {
    template: "$template",
  })
  onResize(entry) {
    const { width } = entry.contentRect;
    this.isNarrow = width < BREAKPOINT_WIDTHS.md;
  }
}

export default contentBrick;
